;(function() {
  'use strict'

  angular
    .module('core.filters')
    .filter('interactionsByUnread', interactionsByUnread)

  /* @ngInject */
  function interactionsByUnread() {
    /**
     * @name interactionsByWord
     * @description filter grouped interactions by unread
     * @param {[]} input array of interaction objects
     * @param {Boolean} unread should be only unread or not?
     * @returns {[]} array of arrays of interactions containing the text in its content or user comments
     */
    return function(input, unread) {
      // return input or empty array if no input or unread is set to false
      if (!input || !unread) {
        return input || []
      }

      var result = []

      _.forEach(input, function(group) {
        var groupResult = []

        _.forEach(group, function(interaction) {
          if (!interaction.actionedBy) {
            groupResult.push(interaction)
          }
        })

        if (groupResult.length > 0) {
          result.push(groupResult)
        }
      })
      return result
    }
  }
})()
